import React from 'react'

export default () => (
    <svg width="1321" height="68" viewBox="0 0 1321 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter14_d)">
            <path className="path-1"
                  d="M686.457 56.0939L583.525 56.0939L438.223 56.0939L375.028 11.0316L10 11.0316V12.7385L374.07 12.7385L437.266 57.8008L583.525 57.8008L686.457 57.8008L824.338 57.8008L887.294 12.7385L1311 12.7385V11.0316L886.336 11.0316L823.38 56.0939L686.457 56.0939Z"
                  fill="white"/>
            <path className="path-2"
                  d="M625.895 42.0973L449.713 42.0973L405.189 10.5196L403.514 11.7144L448.756 43.8042L625.895 43.8042H644.087L821.226 43.8042L865.271 12.3972L863.835 11.2023L820.268 42.0973L644.087 42.0973H625.895Z"
                  fill="white"/>
        </g>
        <defs>
            <filter id="filter14_d" x="0" y="0.519531" width="1321" height="67.2814" filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset/>
                <feGaussianBlur stdDeviation="5"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.596078 0 0 0 0 1 0 0 0 1 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>
)
